export const rotasComuns = [
    {
        path: '/sistema',
        name: 'AppLayout',
        component: () => import('@/layout/AppLayout.vue'),
        meta: {
            requireAuth: true,
        },
        children: [],
    },
    {
        // App do ACS (PWA, tela cheia, login dos servidores): /acs/ — escopo do service worker /sw-acs.js
        path: '/acs/',
        name: 'AcsApp',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/acs/AcsAppPage.vue')
    },
    {
        // App de vendas do financeiro (PWA, tela cheia, mesmo login do sistema): /fin/app/ — escopo do service worker /sw-vendas.js
        path: '/fin/app/',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/fin/appvendas/appVendasPage.vue'),
        children: [
            { path: '', name: 'AppVendasInicio', component: () => import('@/views/fin/appvendas/appVendasInicio.vue') },
            { path: 'venda/cliente', name: 'AppVendasCliente', component: () => import('@/views/fin/appvendas/appVendasCliente.vue') },
            // cadastro rápido: 'novo' ou o cdpessoa (id no último segmento)
            { path: 'venda/cliente/:id', name: 'AppVendasClienteEditar', component: () => import('@/views/fin/appvendas/appVendasClienteEditar.vue') },
            { path: 'venda/produtos', name: 'AppVendasProdutos', component: () => import('@/views/fin/appvendas/appVendasProdutos.vue') },
            { path: 'venda/pagamento', name: 'AppVendasPagamento', component: () => import('@/views/fin/appvendas/appVendasPagamento.vue') },
            // venda já gravada: :id = cdvenda codificado
            { path: 'venda/nota/:id', name: 'AppVendasNota', component: () => import('@/views/fin/appvendas/appVendasNota.vue') },
            // resultado da NF-e: :id = cdnfe codificado
            { path: 'nfe/:id', name: 'AppVendasNotaResultado', component: () => import('@/views/fin/appvendas/appVendasNotaResultado.vue') },
        ]
    },
    {
        // App do cidadão (PWA, público, tela cheia): /app/<cdcliente>; /app/ volta para o último município usado
        path: '/app/:cdcliente?',
        name: 'AppCidadao',
        component: () => import('@/views/homepage/AppCidadaoPage.vue')
    },
    {
        path: '/fin/catalogovenda/:uuid',
        name: 'CatalogoVenda',
        component: () => import('@/views/fin/catalogo/CatalogoVenda.vue')
    },
    {
        path: '/painel',
        name: 'PainelChamada',
        component: () => import('@/views/painel/PainelChamadaPage.vue')
    },
    {
        path: '/painel/parear',
        name: 'PainelParear',
        meta: {
            requireAuth: true,
        },
        component: () => import('@/views/painel/PainelPareamentoPage.vue')
    },
    {
        path: '/teste',
        name: 'testePage',
        component: () => import('@/views/testePage.vue')
    },
    {
        path: '/teste2',
        name: 'testePage2',
        component: () => import('@/views/testePage2.vue')
    },
    {
        path: '/errorpage',
        name: 'errorPage',
        component: () => import('@/views/errorPage.vue')
    },
    {
        path: '/acessonegado',
        name: 'accessDenied',
        component: () => import('@/views/auth/AccessDenied.vue')
    },
    {
        path: '/login',
        name: 'loginPage',
        component: () => import('@/views/auth/LoginPage.vue')
    },
    {
        path: '/logout',
        name: 'logoutPage',
        component: () => import('@/views/auth/LogoutPage.vue')
    },
    {
        path: '/404',
        name: 'notFound',
        component: () => import('@/views/notFound.vue')
    },


    {
        // site institucional novo (isolado: CSS em @/assets/site/site.css)
        path: '/',
        name: 'SiteLayout',
        component: () => import('@/views/homepage/SiteLayout.vue'),
        children: [
            {
                path: '/',
                name: 'homepage',
                component: () => import('@/views/homepage/SiteHome.vue')
            },
            {
                path: '/financeiro',
                name: 'SiteFinanceiro',
                component: () => import('@/views/homepage/SiteFinanceiro.vue')
            },
            {
                path: '/saude',
                name: 'SiteSaude',
                component: () => import('@/views/homepage/SiteSaude.vue')
            },
            {
                path: '/planos',
                name: 'SitePlanos',
                component: () => import('@/views/homepage/SitePlanos.vue')
            },
            {
                path: '/contato',
                name: 'SiteContato',
                component: () => import('@/views/homepage/SiteContato.vue')
            },
            {
                path: '/contratar',
                name: 'SiteContratar',
                component: () => import('@/views/homepage/SiteContratar.vue')
            },
        ],
    },

    {
        path: '/',
        name: 'templatehomepage',
        component: () => import('@/views/homepage/TemplateHomePage.vue'),
        children: [
            {
                path: '/licenciamento',
                name: 'licenciamento',
                component: () => import('@/views/homepage/LicencasPage.vue')
            },
            {
                path: '/renovar-licenca',
                name: 'RenovarLicenca',
                component: () => import('@/views/homepage/RenovarLicencaPage.vue')
            },
            {
                path: '/pagamento-licenca',
                name: 'LicencaPagamento',
                component: () => import('@/views/homepage/LicencaPagamento.vue')
            },
            {
                path: '/pix-qrcode',
                name: 'PixQRCode',
                component: () => import('@/views/homepage/PixQRCodePage.vue')
            },
            {
                path: '/pix-automatico',
                name: 'PixAutomaticoPage',
                component: () => import('@/views/homepage/PagamentoPixAutomaticoPage.vue')
            },
            {
                path: '/privacy',
                name: 'PrivacyPage',
                component: () => import('@/views/homepage/PrivacyPage.vue')
            },
            {
                path: '/politica-de-privacidade',
                name: 'PoliticaPrivacidade',
                component: () => import('@/views/homepage/PrivacyPage.vue')
            },
            {
                path: '/chamados',
                name: 'chamados',
                exact: true,
                meta: {
                    requireAuth: true,
                },
                component: () => import('@/views/homepage/ChamadosPage.vue')
            },
            {
                path: '/chamado/:id',
                name: 'chamadoEditar',
                exact: true,
                meta: {
                    requireAuth: true,
                },
                component: () => import('@/views/homepage/ChamadosEditarPage.vue')
            },
            {
                path: '/chamado/visualizar/:id',
                name: 'chamadoVisualizar',
                exact: true,
                meta: {
                    requireAuth: true,
                },
                component: () => import('@/views/homepage/ChamadosVisualizarPage.vue')
            },

            {
                path: '/validar-receituario/:uuid?',
                name: 'ValidarReceituario',
                exact: true,
                component: () => import('@/views/homepage/ValidarReceituarioPage.vue')
            },
            {
                path: '/validar-atestado/:uuid?',
                name: 'ValidarAtestado',
                exact: true,
                component: () => import('@/views/homepage/ValidarAtestadoPage.vue')
            },
            {
                path: '/validar-solicitacao/:uuid?',
                name: 'ValidarSolicitacao',
                exact: true,
                component: () => import('@/views/homepage/ValidarSolicitacaoPage.vue')
            },
            {
                path: '/validar-solicitacao-simplificada/:uuid?',
                name: 'ValidarSolicitacaoSimplificada',
                exact: true,
                component: () => import('@/views/homepage/ValidarSolicitacaoSimplificadaPage.vue')
            },
            {
                // portal público da fila de regulação (sem login)
                path: '/fila-espera/:cdcliente',
                name: 'FilaEspera',
                exact: true,
                component: () => import('@/views/homepage/FilaEsperaPage.vue')
            },
            {
                path: '/validar-atendimento/:uuid?',
                name: 'ValidarAtendimento',
                exact: true,
                component: () => import('@/views/homepage/ValidarAtendimentoPage.vue')
            },
            {
                path: '/sistema-detalhe/:slug',
                name: 'SistemaDetalhe',
                component: () => import('@/views/homepage/__oldhomepage/SistemaDetalhesPage.vue')
            },
            {
                // cadastro antigo (teste grátis) — agora vai para a contratação do site novo
                path: '/cadastro/:slug',
                name: 'CadastroSistema',
                redirect: (to) => ({ path: '/contratar', query: { produto: to.params.slug === 'sautec' ? 'clinica' : 'financeiro' } })
            },

        ],
    },




    {
        path: '/:catchAll(.*)',
        name: 'catchall',
        component: () => import('@/components/RouteChecker.vue')
    },
]
